import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { BiometricDetailsReportListing } from './Pages'

export const BiometricDetailsReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={BiometricDetailsReportListing} />
    </Fragment>
)